import PurebrandLoader from "components/Loader/PurebrandLoader";
import PurebrandToast from "components/Toasts/Toast";
import DataContext from "context/DataContext";
import React, { useContext, useState } from "react";
import Form from "react-bootstrap/Form";
import useCan from "hooks/useCan";
import { extractErrorMessage } from "utils/apiErrors";
import { capitalizeFirst } from "utils/stringFormatter";

const AssignNewRole = () => {
  const { assignNewRole } = useContext(DataContext);
  // Roles a team manager may hand out come from the backend, so a new role
  // appears here without a frontend change.
  const { assignableRoles } = useCan();

  const [validated, setValidated] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showErr, setShowErr] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [fname, setFName] = useState("");
  const [lname, setLName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const toastPopup = () => {
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  const toastError = () => {
    setShowErr(true);
    setTimeout(() => {
      setShowErr(false);
    }, 5000);
  };

  const handleCloseToast = () => {
    setShowToast(false);
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    setValidated(true);

    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setLoading(false);
      return;
    }

    // The store is resolved server-side from the caller's account.
    let data = {
      email: email,
      first_name: capitalizeFirst(fname),
      last_name: capitalizeFirst(lname),
      role: Number(roleId),
    };

    try {
      let res = await assignNewRole(data);
      if (res.status === 201) {
        form.reset();
        setEmail("");
        setFName("");
        setLName("");
        setRoleId("");
        toastPopup();
        setValidated(false);
      }
    } catch (err) {
      setErrorMessage(extractErrorMessage(err));
      toastError();
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <PurebrandLoader />;
  }

  return (
    <>
      <PurebrandToast
        show={showToast}
        onClose={handleCloseToast}
        title="Success"
        message="Successfully assigned."
      />
      <div className="card cardc p-5">
        <div className="h5">Assign New Role</div>
        <hr />
        {showErr && <p className="text-danger">{errorMessage}</p>}
        <Form noValidate validated={validated} onSubmit={handleSubmit} id="assign-role-form">
          <Form.Group>
            <div className="row mb-3">
              <div className="col-6 col-sm-12 col-md-6">
                <Form.Label>First name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="First name"
                  value={fname}
                  onChange={(e) => {
                    setFName(e.target.value);
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter First Name.
                </Form.Control.Feedback>
              </div>
              <div className="col-6 col-sm-12 col-md-6">
                <Form.Label>Last name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Last name"
                  value={lname}
                  onChange={(e) => {
                    setLName(e.target.value);
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Last Name.
                </Form.Control.Feedback>
              </div>
            </div>
          </Form.Group>
          <Form.Group>
            <div className="row mb-3">
              <div className="col-6 col-sm-12 col-md-6">
                <Form.Label>Enter Email</Form.Label>
                <Form.Control
                  required
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter valid email.
                </Form.Control.Feedback>
              </div>
              <div className="col-6 col-sm-12 col-md-6">
                <Form.Label>Assign Role</Form.Label>
                <Form.Control
                  as="select"
                  className="form-select"
                  value={roleId}
                  required
                  onChange={(e) => {
                    setRoleId(e.target.value);
                  }}
                >
                  <option value="" disabled>
                    Select Role
                  </option>
                  {assignableRoles.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Please assign role.
                </Form.Control.Feedback>
              </div>
            </div>
          </Form.Group>
        </Form>

        <div className="text-end m-2">
          <button
            className="btn btn-primary"
            type="submit"
            form="assign-role-form"
            disabled={roleId === ""}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default AssignNewRole;
